import { format } from "date-fns";
import { Tooltip } from "react-tooltip";

import { AssetModel } from "@interfaces/index";
import { formatAmount, getUploadLaterTooltipContentStr } from "@utils/index";
import {
  ChevronRightSvg,
  AssetItem,
  AlertTriangleSvg,
} from "@components/index";

export const TableRowAsset = ({
  asset,
  showDisposal = false,
  onDetails,
}: {
  asset: AssetModel;
  showDisposal: boolean;
  onDetails: () => void;
}) => (
  <tr
    className="cursor-pointer border-b border-b-black-16 text-black-100 hover:bg-black-4"
    onClick={onDetails}
    data-testid="tr_assetsTable"
  >
    <td className="py-6">
      <AssetItem type={asset.type} />
    </td>
    <td className="py-6">
      <div
        className="flex w-fit items-center"
        data-tooltip-id={`tooltip-upload-later-${asset.uniqueId}`}
        data-tooltip-variant="light"
        data-tooltip-class-name="!rounded-lg shadow-md !p-4 !text-100"
        data-tooltip-html={getUploadLaterTooltipContentStr(asset)}
      >
        {asset.uploadLaterAgreement || asset.uploadLaterInvoice ? (
          <div className="mr-0.5 hidden md:block">
            <AlertTriangleSvg />
          </div>
        ) : null}
        <div className="max-w-36 truncate">{asset.name}</div>
        {asset.isDefault && (
          <span className="text-100 font-normal text-black-54">
            <span className="pl-1"> • </span>
            Default
          </span>
        )}
      </div>
      {asset.uploadLaterAgreement || asset.uploadLaterInvoice ? (
        <>
          <Tooltip
            id={`tooltip-upload-later-${asset.uniqueId}`}
            className="hidden md:block"
          />
          <div className="mt-1 flex items-center text-100 text-black-70 *:mr-1 *:size-4 md:hidden">
            <AlertTriangleSvg />
            Documents required
          </div>
        </>
      ) : null}
    </td>
    <td className="hidden py-6 md:table-cell">{formatAmount(asset.cost)}</td>
    {showDisposal && (
      <td className="hidden py-6 xl:table-cell">
        {formatAmount(asset.disposal?.cost)}
      </td>
    )}
    <td className="hidden py-6 text-black-54 md:table-cell">
      {format(new Date(asset.date), "dd.MM.yyyy")}
    </td>
    {showDisposal && (
      <td className="hidden py-6 text-black-54 xl:table-cell">
        {format(new Date(asset.disposal?.date || ""), "dd.MM.yyyy")}
      </td>
    )}
    <td className="hidden max-w-40 truncate py-6 text-black-54 lg:table-cell">
      <span title={showDisposal ? asset.disposal?.comment : asset.comment}>
        {showDisposal ? asset.disposal?.comment : asset.comment}
      </span>
    </td>
    <td className="py-6">
      <ChevronRightSvg />
    </td>
  </tr>
);
